/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Rate response
 */
export interface RateResponse {
  pairName: string;
  buyQuantity?: number;
  /**
   * Rate for buy operation.
   */
  buyRate?: number;
  /**
   * Total for buy operation for specified quantity.
   */
  buyTotal?: number;
  sellQuantity?: number;
  /**
   * Rate for sell operation.
   */
  sellRate?: number;
  /**
   * Total for sell operation for specified quantity.
   */
  sellTotal?: number;
}
